// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"f1e63104","133":"8b5600bf","502":"aba729ce"}[chunkId] + ".chunk.js";
};